const { fetchSdkDiagnostics } = require('../http');

function fetchDiagnostics(ctx) {
  return fetchSdkDiagnostics(ctx.pgOrigin, ctx.apiKey, ctx.merchant_id);
}

module.exports = { fetchDiagnostics };
